import { render, staticRenderFns } from "./WorksEdit.vue?vue&type=template&id=e4847196&scoped=true"
import script from "./WorksEdit.vue?vue&type=script&lang=js"
export * from "./WorksEdit.vue?vue&type=script&lang=js"
import style0 from "./WorksEdit.vue?vue&type=style&index=0&id=e4847196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4847196",
  null
  
)

export default component.exports